export default function LocationSection() {
  return (
    <section id="location" className="bg-studio-dark py-24 md:py-32 px-6 md:px-12 lg:px-16">
      <div className="w-full max-w-5xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="text-studio-gray/30 font-bebas text-[clamp(60px,10vw,140px)] leading-none block">
            06
          </span>
          <h2
            className="text-white font-bebas uppercase leading-none -mt-6 md:-mt-12"
            style={{ fontSize: 'clamp(40px, 6vw, 80px)', lineHeight: 1 }}
          >
            오시는 길
          </h2>
          <p className="text-studio-gray font-sans text-lg md:text-xl mt-4">
            경기 파주시 경의로1004번길 37 4층 웨스트사운드
          </p>
        </div>

        {/* Naver Map iframe */}
        <div className="rounded-lg overflow-hidden border border-studio-border mb-8">
          <iframe
            src="https://m.place.naver.com/place/2031289046/location"
            width="100%"
            height="400"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="TROUBLE STUDIO 네이버 지도"
            className="w-full h-[320px] md:h-[400px]"
          />
        </div>

        {/* Info cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-studio-card border border-studio-border rounded-lg p-6 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
              <i className="ri-map-pin-2-line text-studio-gold text-2xl" />
            </div>
            <h3 className="text-white font-sans font-bold text-sm mb-1">주소</h3>
            <p className="text-studio-silver font-sans text-sm">
              경기 파주시 경의로1004번길 37
              <br />
              4층 웨스트사운드
            </p>
          </div>
          <div className="bg-studio-card border border-studio-border rounded-lg p-6 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
              <i className="ri-phone-line text-studio-gold text-2xl" />
            </div>
            <h3 className="text-white font-sans font-bold text-sm mb-1">연락처</h3>
            <p className="text-studio-silver font-sans text-sm">0507-1315-7372</p>
          </div>
          <div className="bg-studio-card border border-studio-border rounded-lg p-6 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
              <i className="ri-train-line text-studio-gold text-2xl" />
            </div>
            <h3 className="text-white font-sans font-bold text-sm mb-1">교통</h3>
            <p className="text-studio-silver font-sans text-sm">
              야당역 1번 출구
              <br />
              도보 약 5분
            </p>
          </div>
        </div>

        {/* Naver map button */}
        <div className="text-center">
          <a
            href="https://m.place.naver.com/place/2031289046/location"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#03C75A] text-white font-sans font-bold text-base md:text-lg px-8 md:px-10 py-4 rounded-full hover:bg-[#02A84C] transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
              <i className="ri-map-pin-line text-2xl" />
            </div>
            네이버 지도에서 보기
          </a>
        </div>
      </div>
    </section>
  );
}